import { render, staticRenderFns } from "./FmItem.vue?vue&type=template&id=1c535a0d&scoped=true&"
import script from "./FmItem.vue?vue&type=script&lang=js&"
export * from "./FmItem.vue?vue&type=script&lang=js&"
import style0 from "./FmItem.vue?vue&type=style&index=0&id=1c535a0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c535a0d",
  null
  
)

export default component.exports